import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { food_list } from "../../assets/assets";
import { useDispatch, useSelector } from "react-redux";
import cross from '../../assets/cross_icon.png'
import './Cart.css';
import { action } from "../../store/CartCounter";

function Cart() {
  const cartItems = useSelector((state) => {
    return state;
  });

  const dispatcher =useDispatch()
  
  const getTotalCartAmount=()=>{
    let totalAmount=0;
    for(const item in cartItems){
      if(cartItems[item]>0){
        let itemInfo= food_list.find((product)=>product._id===item)
        totalAmount+=(itemInfo.price*cartItems[item]);
      }
    }
    return totalAmount;
}
  return (
    <div>
      <Navbar/>
      <section className="cart">
      <div className="container">
        <div className="row cart-items-title">
          <p className="col-2">Items</p>
          <p className="col-2">Title</p>
          <p className="col-2">Price</p>
          <p className="col-2">Quatity</p>
          <p className="col-2">Total</p>
          <p className="col-2">Remove</p>
        </div>
        <div className="cart-item-list">
          {food_list.map((item, index) => {
            if (cartItems[item._id] > 0) {
              return (
                <div className="row cart-items" key={index}>
                  <p className="col-2"><img src={item.image} alt={item.name} /></p>
                  <p className="col-2">{item.name}</p>
                  <p className="col-2">${item.price}</p>
                  <p className="col-2">{cartItems[item._id]}</p>
                  <p className="col-2">${item.price*cartItems[item._id]}</p>
                  <p className="col-2"><span onClick={()=>dispatcher(action.completeRemove(item._id))}><img className="cross-btn2" src={cross} alt="cross btn"/></span></p>
                </div>
              );
            }
            return '';
          })}
        </div>
          <div className="row justify-content-between py-4">
            <div className="col-5">
              <div className="cart-total">
                <h4>Cart Totals</h4>
                <div className="cart-total-datails">
                  <div className="cart-total-item">
                    <span>Subtotal</span>
                    <span>${getTotalCartAmount()}</span>
                  </div>
                  <div className="cart-total-item">
                    <span>Delivery fee</span>
                    <span>${2}</span>
                  </div>
                  <div className="cart-total-item">
                    <span>Total</span>
                    <span>${getTotalCartAmount()+2}</span>
                  </div>
                </div>
                <button className="payment-btn">Proceed to Payment</button>
              </div>
            </div>
            <div className="col-5">
              <div>
                <p className="promocode-para">If you have promo code. Enter it here</p>
                <div className="promo-input">
                  <input type="text" placeholder="Enter promocode"/>
                  <button className="promo-submit">submit</button>
                </div>
              </div>
            </div>
          </div>
      </div>
      </section>
      <Footer />
    </div>
  );
}

export default Cart;
